export enum Endpoints {
  LOA_SUBMISSION_TOKEN = 'LOA_SUBMISSION_TOKEN',

}
